import { StepGroup } from "../step/StepGroup";
import { Step } from "../step/Step";
import { StepGroupTypes } from "../../enum/StepGroupTypes";

export class Wizard {
    private _stepActive: number;
    private _groupActive: number;
    private _structure: StepGroup[];
    private _hasAutoScaling: boolean;

    constructor(structure: any[], hasAutoScaling: boolean, processConfigurationPayExemptions: any[],processConfigurationAuthorizations : any[]) {
        this._stepActive = 0;
        this._groupActive = 0;
        this._structure = structure.map((stepGroup: any) => new StepGroup(stepGroup, processConfigurationPayExemptions,processConfigurationAuthorizations));
        this._hasAutoScaling = hasAutoScaling;
    }

    public get stepActive(): number {
        return this._stepActive;
    }

    public get groupActive(): number {
        return this._groupActive;
    }

    public get structure(): StepGroup[] {
        return this._structure;
    }

    public set stepActive(step: number) {
        this._stepActive = step;
    }

    public set groupActive(type: number) {
        this._groupActive = type;
    }

    public set hasAutoScaling(hasAutoScaling: boolean) {
        this._hasAutoScaling = hasAutoScaling;
    }

    public get hasAutoScaling(): boolean {
        return this._hasAutoScaling;
    }

    public getRequirementIndexStructure(){
        return this._structure.findIndex(element => element.type === StepGroupTypes.enum.REQUIREMENTSWIZARD);
    }

    public getMeritsIndexStructure(){
        return this._structure.findIndex(element => element.type === StepGroupTypes.enum.MERITS);
    }

    public getExamsIndexStructure(){
        return this._structure.findIndex(element => element.type === StepGroupTypes.enum.CREDITABLEEXAMS);
    }

    public getPaymentIndexStructure(){
        return this._structure.findIndex(element => element.type === StepGroupTypes.enum.PAYWIZARD);
    }

    public getStep(groupType: number, stepOrder: number) {
        const firstGroup = this._structure.filter((group: StepGroup) => group.type == groupType)[0]
        if (!firstGroup) return null
        return firstGroup.steps.filter((step: Step) => step.order == stepOrder)[0];
    }

    public clearErrors() {
        this._structure.forEach((group: StepGroup) => group.steps.forEach((step: Step) => step.error = false));
    }

    public nextStep() {
        const currentGroupIndex = this._structure.findIndex((group: StepGroup) => group.type === this.groupActive);
        const currentStepIndex = this._structure[currentGroupIndex].steps.indexOf(this.getStep(this.groupActive, this.stepActive));
        if (currentStepIndex < this._structure[currentGroupIndex].steps.length - 1) {
            this.stepActive = this._structure[currentGroupIndex].steps[currentStepIndex + 1].order;
        } else if (currentGroupIndex < this._structure.length - 1) {
            this.groupActive = this._structure[currentGroupIndex + 1].type;
            this.stepActive = this._structure[currentGroupIndex + 1].steps[0].order;
        }
        if (this._groupActive === 3) {
            window.scrollTo(0,0);
        }
    }

    public prevStep() {
        const currentGroupIndex = this._structure.findIndex((group: StepGroup) => group.type === this.groupActive);
        const currentStepIndex = this._structure[currentGroupIndex].steps.indexOf(this.getStep(this.groupActive, this.stepActive));
        if (currentStepIndex > 0) {
            this.stepActive = this._structure[currentGroupIndex].steps[currentStepIndex - 1].order;
        } else if (currentGroupIndex > 0) {
            this.groupActive = this._structure[currentGroupIndex - 1].type;
            this.stepActive = this._structure[currentGroupIndex - 1].steps[this._structure[currentGroupIndex - 1].steps.length - 1].order;
        }
        if (this._groupActive === 3) {
            window.scrollTo(0,0);
        }
    }

}